import { render, staticRenderFns } from "./CargoListBottomContent.vue?vue&type=template&id=4b397c50"
import script from "./CargoListBottomContent.vue?vue&type=script&lang=js"
export * from "./CargoListBottomContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports